import React from 'react';
import { PropTypes } from 'prop-types';
import { selectors as authSelectors } from 'state/auth';
import { useSelector } from 'react-redux';
// styles
import styled, { css } from 'styled-components';
import { ResponsiveHide } from 'refactored/ui/utils';

const limitSize = css`
  /* when text is long we limit with so it stays in 1 line */
  max-width: 150px;
  max-height: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const UserName = styled.div`
  font-size: 14px;
  line-height: 16px;
  color: var(--grey700);
  font-weight: 500px;
  margin-bottom: 2px;
  ${limitSize}
`;

const UserCompany = styled.div`
  font-size: 14px;
  line-height: 16px;
  margin-top: 2px;
  color: var(--grey500);
  ${limitSize}
`;

const UserInfo = ({ className }) => {
  const user = useSelector(authSelectors.getUser);
  const userName = user?.name;
  const companyName = user?.company_name;
  return (
    <ResponsiveHide hideMobile className={className}>
      <UserName>{userName}</UserName>
      <UserCompany>{companyName}</UserCompany>
    </ResponsiveHide>
  );
};

UserInfo.propTypes = {
  className: PropTypes.string,
};

const StyledUserInfo = styled(UserInfo)`
  border-left: 1px solid var(--grey-mouse);
  text-align: right;
  padding: 0px 16px;
`;

export default StyledUserInfo;
